import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(1),
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[400],
  borderRadius: (p) => p.spacing(1),
  height: '100%',
};
